import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import ENDPOINTS, { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'

type UseVariantDetailsProps = {
  variantId?: string | number
  options?: UseQueryOptions
}

type VariantDetails = {
  data: {
    id: number
    name: string
    partnerId: number
    groupCode: number
    groupName: string
    categoryId: number
    partnerCategoryId?: number
    categoryName: string
    imageUrl: string
    payout?: {
      amount: number
      type: string
    }
    salaryRangeIncomeCriteria: {
      salaried: {
        text: string
        value: number
      }
      selfEmployed: {
        text: string
        value: number
      }
    }
    topBenefitsBrandDetail: Array<{
      tag: string
      icon: string
      heading: string
      subText: Array<string>
    }>

    topBenefitsBrandCard: Array<{
      tag: string
      icon: string
      heading: string
      subText: Array<string>
    }>
    detailedBenefits: Array<{
      tag: string
      icon: string
      heading: string
      subText: Array<string>
    }>
    defaultRejectionPayout: string
    isPartnerOnHold: boolean
    isNewBrand: boolean
    isSpendBasedWaiver: boolean
  }
}

const getVariantDetails = async ({
  queryKey: [_, variantId],
}: {
  queryKey: Array<string>
}) => {
  const { data } = await zetApi.request({
    url: `${ENDPOINTS[APP_NAME].getVariantDetailsById.endpoint}/${variantId}`,
    method: ENDPOINTS[APP_NAME].getVariantDetailsById.method,
  })
  return data?.data
}

const useVariantDetails = ({ variantId }: UseVariantDetailsProps) => {
  return useQuery<
    VariantDetails['data'],
    Error,
    VariantDetails['data'],
    unknown
  >({
    queryKey: ['variant', variantId?.toString()],
    queryFn: getVariantDetails,
    enabled: !!variantId,
  })
}

export default useVariantDetails
